import { render } from "./MarketingCampaignsPage.vue?vue&type=template&id=5d62ce25&scoped=true"
import script from "./MarketingCampaignsPage.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignsPage.vue?vue&type=script&lang=js"

import "./MarketingCampaignsPage.vue?vue&type=style&index=0&id=5d62ce25&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d62ce25"]])

export default __exports__